import InputField from "components/fields/InputField";
import React, { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa";
import Calculation from "./Calculation";
import { useWatch } from "react-hook-form";
import CustomerDetails from "./CustomerDetails";
import userResources from "api/userResources";

export default function Insurance({
  insurance,
  register,
  errors,
  insuranceFields,
  appendinsurance,
  removeinsurance,
  clearErrors,
  watch,
  setValue,
  getValues,
  control,
  updateData,
}) {
  // Watch the entire passenger_details array from the airticket section.
  const passengerDetails = useWatch({
    control,
    name: "airticket.passenger_details",
  });

  // useEffect(() => {
  //   // Get the current insurance entries from the form (nested under "insurance")
  //   if (!updateData) {
  //     // const currentInsurance =
  //     //   getValues("insurance.insurance_passenger_details") || [];

  //     // // // 1. For each passenger with add_insurance === true, ensure there is an insurance entry.
  //     // passengerDetails?.forEach((passenger, passengerIndex) => {
  //     //   if (passenger.add_insurance) {
  //     //     // Look for an existing insurance entry for this passenger index.
  //     //     const existingIndex = currentInsurance.findIndex(
  //     //       (ins) => ins.passengerIndex === passengerIndex
  //     //     );

  //     //     if (existingIndex === -1) {
  //     //       // Check if there's an "empty" insurance entry we can fill.
  //     //       const emptyIndex = currentInsurance.findIndex(
  //     //         (ins) =>
  //     //           (ins.passengerIndex === undefined ||
  //     //             ins.passengerIndex === null) &&
  //     //           ins.first_name === "" &&
  //     //           ins.last_name === ""
  //     //       );

  //     //       if (emptyIndex !== -1) {
  //     //         setValue(
  //     //           `insurance.insurance_passenger_details[${emptyIndex}].first_name`,
  //     //           passenger.first_name || ""
  //     //         );
  //     //         setValue(
  //     //           `insurance.insurance_passenger_details[${emptyIndex}].last_name`,
  //     //           passenger.last_name || ""
  //     //         );
  //     //         setValue(
  //     //           `insurance.insurance_passenger_details[${emptyIndex}].passengerIndex`,
  //     //           passengerIndex
  //     //         );
  //     //         clearErrors("insurance.insurance_passenger_details");
  //     //       } else {
  //     //         // Append a new insurance entry.
  //     //         appendinsurance({
  //     //           first_name: passenger.first_name || "",
  //     //           last_name: passenger.last_name || "",
  //     //           passengerIndex, // Store the originating passenger's index
  //     //         });
  //     //       }
  //     //     } else {
  //     //       // If an entry exists, update the names.
  //     //       setValue(
  //     //         `insurance.insurance_passenger_details[${existingIndex}].first_name`,
  //     //         passenger.first_name || ""
  //     //       );
  //     //       setValue(
  //     //         `insurance.insurance_passenger_details[${existingIndex}].last_name`,
  //     //         passenger.last_name || ""
  //     //       );
  //     //     }
  //     //   }
  //     // });

  //     // 2. Remove any insurance entry that no longer corresponds to a passenger with add_insurance === true.
  //     // const updatedInsurance =
  //     //   getValues("insurance.insurance_passenger_details") || [];
  //     // for (let i = updatedInsurance.length - 1; i >= 0; i--) {
  //     //   const ins = updatedInsurance[i];

  //     //   // If this entry is flagged as default, skip removal.
  //     //   if (ins.isDefault) continue;

  //     //   if (
  //     //     ins.passengerIndex !== null &&
  //     //     (!passengerDetails[ins.passengerIndex] ||
  //     //       !passengerDetails[ins.passengerIndex].add_insurance)
  //     //   ) {
  //     //     removeinsurance(i);
  //     //   }
  //     // }
  //   }
  // }, [passengerDetails, setValue, getValues, appendinsurance, removeinsurance]);

  const [supplierData, setSupplierData] = useState([]);

  const getSuppliers = async () => {
    try {
      const response = await userResources.supplier();
      const combinedData = response.data.data.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setSupplierData(combinedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const toBoolean = (value) => String(value).toLowerCase() === "true";

    setValue(
      "insurance.insurance_details.insurance_provider",
      updateData?.insurance?.insurance_details?.insurance_provider
    );
    setValue(
      "insurance.insurance_details.policy_number",
      updateData?.insurance?.insurance_details?.policy_number
    );
    setValue(
      "insurance.insurance_details.effective_date",
      updateData?.insurance?.insurance_details?.effective_date
    );
    setValue(
      "insurance.insurance_details.termination_date",
      updateData?.insurance?.insurance_details?.termination_date
    );
    setValue(
      "insurance.insurance_details.amount_insured",
      updateData?.insurance?.insurance_details?.amount_insured
    );
    setValue(
      "insurance.insurance_details.insurance_plan",
      updateData?.insurance?.insurance_details?.insurance_plan
    );

    // calculation updateData
    // insurance
    setValue(
      `insurance.passengers.adt`,
      Number(updateData?.insurance?.passengers?.adt)
    );
    setValue(
      `insurance.passengers.chd`,
      Number(updateData?.insurance?.passengers?.chd)
    );
    setValue(
      `insurance.passengers.inf`,
      Number(updateData?.insurance?.passengers?.inf)
    );
    setValue(
      `insurance.insurance_from_pax.baseFare.adt1`,
      Number(updateData?.insurance?.insurance_from_pax?.baseFare?.adt1)
    );
    setValue(
      `insurance.insurance_from_pax.baseFare.chd1`,
      Number(updateData?.insurance?.insurance_from_pax?.baseFare?.chd1)
    );
    setValue(
      `insurance.insurance_from_pax.baseFare.inf1`,
      Number(updateData?.insurance?.insurance_from_pax?.baseFare?.inf1)
    );
    setValue(
      `insurance.insurance_from_pax.taxes.adt1`,
      Number(updateData?.insurance?.insurance_from_pax?.taxes?.adt1)
    );
    setValue(
      `insurance.insurance_from_pax.taxes.chd1`,
      Number(updateData?.insurance?.insurance_from_pax?.taxes?.chd1)
    );
    setValue(
      `insurance.insurance_from_pax.taxes.inf1`,
      Number(updateData?.insurance?.insurance_from_pax?.taxes?.inf1)
    );
    setValue(
      `insurance.insurance_from_pax.amountPaid`,
      Number(updateData?.insurance?.insurance_from_pax?.amountPaid)
    );
    setValue(
      `insurance.insurance_from_pax.refund`,
      Number(updateData?.insurance?.insurance_from_pax?.refund)
    );
    setValue(
      `insurance.insurance_from_pax.refund_paid`,
      Number(updateData?.insurance?.insurance_from_pax?.refund_paid)
    );
    setValue(
      `insurance.insurance_from_pax.payment_received_from_pax`,
      toBoolean(
        updateData?.insurance?.insurance_from_pax?.payment_received_from_pax
      )
    );
    // Using supplierPax for the key and when accessing updateData
    setValue(
      `insurance.insurance_to_supplier.baseFare.adt1`,
      Number(updateData?.insurance?.insurance_to_supplier?.baseFare?.adt1)
    );
    setValue(
      `insurance.insurance_to_supplier.baseFare.chd1`,
      Number(updateData?.insurance?.insurance_to_supplier?.baseFare?.chd1)
    );
    setValue(
      `insurance.insurance_to_supplier.baseFare.inf1`,
      Number(updateData?.insurance?.insurance_to_supplier?.baseFare?.inf1)
    );
    setValue(
      `insurance.insurance_to_supplier.paymentMade`,
      Number(updateData?.insurance?.insurance_to_supplier?.paymentMade)
    );
    setValue(
      `insurance.insurance_to_supplier.payment_received_from_supplier`,
      Number(
        updateData?.insurance?.insurance_to_supplier
          ?.payment_received_from_supplier
      )
    );
    setValue(
      `insurance.insurance_to_supplier.recall_commission_to_supplier`,
      Number(
        updateData?.insurance?.insurance_to_supplier
          ?.recall_commission_to_supplier
      )
    );
    setValue(
      `insurance.insurance_to_supplier.refund`,
      Number(updateData?.insurance?.insurance_to_supplier?.refund)
    );
    setValue(
      `insurance.insurance_to_supplier.cash_in_hand`,
      Number(updateData?.insurance?.insurance_to_supplier?.cash_in_hand)
    );

    setValue(
      `insurance.insurance_to_supplier.refund_received_from_supplier`,
      toBoolean(
        updateData?.insurance?.insurance_to_supplier
          ?.refund_received_from_supplier
      )
    );
    setValue(
      `insurance.insurance_to_supplier.commission_from_supplier`,
      toBoolean(
        updateData?.insurance?.insurance_to_supplier?.commission_from_supplier
      )
    );
  }, [updateData]);

  useEffect(() => {
    getSuppliers();
  }, []);

  return (
    <section className="p-2">
      <div>
        <p className="bg-[#09c8ff] px-2 text-white">Insurance Details:</p>
      </div>

      {insuranceFields.map((field, index) => (
        <div
          key={field.id}
          className="grid grid-cols-1 items-end gap-x-2 rounded shadow-sm sm:grid-cols-5"
        >
          <div className="sm:col-span-2">
            <InputField
              label="Last Name"
              id={`insurance.insurance_passenger_details[${index}].last_name`}
              type="text"
              placeholder="Enter insurance passenger last name"
              register={register}
              name={`insurance.insurance_passenger_details[${index}].last_name`}
              rules={{ required: "Last Name is required" }}
              errorMessage={
                errors?.insurance?.insurance_passenger_details?.[index]
                  ?.last_name?.message
              }
              onChange={() =>
                clearErrors(
                  `insurance.insurance_passenger_details[${index}].last_name`
                )
              }
              bgAllDark={true}
            />
          </div>
          <div className="sm:col-span-2">
            <InputField
              label="First Name"
              id={`insurance.insurance_passenger_details[${index}].first_name`}
              type="text"
              placeholder="Enter insurance passenger first name"
              register={register}
              name={`insurance.insurance_passenger_details[${index}].first_name`}
              rules={{ required: "First Name is required" }}
              errorMessage={
                errors?.insurance?.insurance_passenger_details?.[index]
                  ?.first_name?.message
              }
              onChange={() =>
                clearErrors(
                  `insurance.insurance_passenger_details[${index}].first_name`
                )
              }
              bgAllDark={true}
            />
          </div>
          {insuranceFields.length > 1 && (
            <button
              type="button"
              onClick={() => {
                const passengerIdx = getValues(
                  `insurance.insurance_passenger_details[${index}].passengerIndex`
                );
                if (passengerIdx !== null) {
                  setValue(
                    `airticket.passenger_details[${passengerIdx}].add_insurance`,
                    false
                  );
                }
                removeinsurance(index);
              }}
              className="rounded-md border-red-500 bg-white py-2 text-red-500 hover:bg-red-500 hover:text-white"
            >
              Remove
            </button>
          )}
        </div>
      ))}

      <button
        type="button"
        onClick={() =>
          appendinsurance({
            first_name: "",
            last_name: "",
            passengerIndex: null,
          })
        }
        className="mt-2 flex items-center rounded-full bg-blue-500 px-1 py-1 text-white hover:bg-blue-600"
      >
        <FaPlus />
      </button>

      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3">
        <InputField
          label="Insurance Provider"
          id="insurance_provider"
          type="text"
          placeholder="Enter Insurance Provider"
          register={register}
          name="insurance.insurance_details.insurance_provider"
          rules={{ required: "Insurance Provider is required" }}
          errorMessage={
            errors?.insurance?.insurance_details?.insurance_provider?.message
          }
          onChange={() =>
            clearErrors("insurance.insurance_details.insurance_provider")
          }
          bgAllDark={true}
        />

        <InputField
          label="Policy No."
          id="policy_no"
          type="text"
          placeholder="Enter Policy Number"
          register={register}
          name="insurance.insurance_details.policy_number"
          rules={{ required: "Policy No. is required" }}
          errorMessage={
            errors?.insurance?.insurance_details?.policy_number?.message
          }
          onChange={() =>
            clearErrors("insurance.insurance_details.policy_number")
          }
          bgAllDark={true}
        />

        <InputField
          label="Effective Date"
          id="effective_date"
          type="date"
          register={register}
          name="insurance.insurance_details.effective_date"
          rules={{ required: "Effective Date is required" }}
          errorMessage={
            errors?.insurance?.insurance_details?.effective_date?.message
          }
          onChange={() =>
            clearErrors("insurance.insurance_details.effective_date")
          }
          bgAllDark={true}
        />

        <InputField
          label="Termination Date"
          id="termination_date"
          type="date"
          register={register}
          name="insurance.insurance_details.termination_date"
          rules={{ required: "Termination Date is required" }}
          errorMessage={
            errors?.insurance?.insurance_details?.termination_date?.message
          }
          onChange={() =>
            clearErrors("insurance.insurance_details.termination_date")
          }
          bgAllDark={true}
        />

        <InputField
          label="Amount Insured"
          id="amount_insured"
          type="number"
          placeholder="Enter Amount Insured"
          register={register}
          name="insurance.insurance_details.amount_insured"
          // rules={{ required: "Amount Insured is required" }}
          // errorMessage={
          //   errors?.insurance?.insurance_details?.amount_insured?.message
          // }
          // onChange={() =>
          //   clearErrors("insurance.insurance_details.amount_insured")
          // }
          bgAllDark={true}
        />

        <InputField
          label="Insurance Plan"
          id="insurance_plan"
          type="text"
          placeholder="Enter Insurance Plan"
          register={register}
          name="insurance.insurance_details.insurance_plan"
          // rules={{ required: "Insurance Plan is required" }}
          // errorMessage={
          //   errors?.insurance?.insurance_details?.insurance_plan?.message
          // }
          // onChange={() =>
          //   clearErrors("insurance.insurance_details.insurance_plan")
          // }
          bgAllDark={true}
        />
      </div>
      <div className="mt-4">
        <Calculation
          supplierData={supplierData}
          insurance={insurance}
          register={register}
          errors={errors}
          clearErrors={clearErrors}
          watch={watch}
          setValue={setValue}
          control={control}
          getValues={getValues}
          insurancePax={true}
          insuranceSupplier={true}
          updateData={updateData}
        />
      </div>
    </section>
  );
}
